"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (percentage) {
    return "rgba(42, 48, 82, " + percentage + ")";
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/misc/brandColor.js
// module id = 648
// module chunks = 0